import { Enums } from "../common"
import { IJsonSerializable } from "../util/interfaces"
import { ReferenceTypeComponent } from "../../helpers"

export class OpRelatedObjects implements IJsonSerializable {

    // #region Properties

    public referenceType: Enums.ReferenceType
    public referenceValue: any
    public relatedReferenceType: Enums.ReferenceType
    public relatedReferenceValues: any[]

    // #endregion

    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion

    // #region IJsonSerializable

    public toJSON(compressed: boolean = false): any {
        return {
            ReferenceType: this.referenceType,
            ReferenceValue: this.referenceValue,
            RelatedReferenceType: this.relatedReferenceType,
            RelatedReferenceValues: this.relatedReferenceValues,
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.referenceType = opObj.ReferenceType
            this.referenceValue = opObj.ReferenceValue != null ? ReferenceTypeComponent.createReferenceObject(this.referenceType, opObj.ReferenceValue) : null
            this.relatedReferenceType = opObj.RelatedReferenceType

            if (opObj.RelatedReferenceValues != null) {
                this.relatedReferenceValues = opObj.RelatedReferenceValues.map((referencedValue: any) => ReferenceTypeComponent.createReferenceObject(this.relatedReferenceType, referencedValue))
            }
        }
    }

    // #endregion

}